<template>
  <section id="new_ref_fifth_step" class="flex">
    <titlePage>
      <template slot="titleBody">
        <div class="hero-head has-text-centered">
          <h1 class="title has-text-weight-light is-size-1">{{ getRefName(associatedRef) }}</h1>
          <h2 class="associated_ref_name">
            {{ $t('modules.refs.formStep5.associatedRef') }} :
            <span>{{ associatedRef.name }}</span>
          </h2>
        </div>
      </template>
    </titlePage>

    <div class="hero subsection_container">
      <div class="hero-body">
        <div class="container mini-container bottom-section">
          <h2
            class="title is-size-1 has-text-weight-bold stepTitle">{{ $t('modules.refs.formStep5.title') }}</h2>

          <div class="share_ref_container">
            <span class="share_label">{{ $t('modules.refs.formStep5.shareRef') }}</span>
            <ShareRefModal :currentRef="currentRef"/>
          </div>
        </div>
      </div>
      <div class="hero-foot">
        <div class="container mini-container bottom-section">
          <div class="bottom_btn_container">
            <btnUnderline link="/refs">
              <span v-html="$t('modules.refs.formStep5.backToListButton')"></span>
            </btnUnderline>
            <btnUnderline :link="'/refs/' + currentRef.id">
              <span v-html="$t('modules.refs.formStep5.EditRefButton')"></span>
            </btnUnderline>
            <btnUnderline @actionClick="reinitNew">
              <span v-html="$t('modules.refs.formStep5.newRefButton')"></span>
            </btnUnderline>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import titlePage from "@/components/layouts/titlePage";
import ShareRefModal from "./shareRefModal";

export default {
  name: "formStep5",
  props: ["isNew", "notOwnedRef"],
  components: {
    titlePage,
    ShareRefModal
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.dispatch("RefStore/createRef", this.currentRef);
  },
  computed: {
    currentRef() {
      return this.$store.state.RefStore.currentRef;
    },
    associatedRef() {
      return this.$store.state.RefStore.currentRef.associated_ref;
    }
  },
  methods: {
    getRefName(refItem){
      if (refItem.ref_type == 'saven'){
          return this.$i18n.t("refs.jobs." + refItem.slug)
      }else{
          return refItem.name
      }
    },
    reinitNew() {
      this.$store.dispatch("RefStore/initNew");
    }
  }
};
</script>

<style lang="scss" >
#new_ref_fifth_step {
  background: $white;

  display: flex;
  flex-direction: column;
  .subsection_container {
    background: $white;
    .hero-body {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 100px;
      .stepTitle {
        max-width: 500px;
        text-align: center;
      }
    }
  }
  .bottom_btn_container {
    display: flex;
    justify-content: space-around;
  }
  .share_ref_container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 42px;
    .share_label {
      font-weight: 500;
      display: block;
      margin-bottom: 20px;
    }
    .share_button {
      font-size: 2rem;
    }
  }
}
</style>